<main>
  <div class="container-fluid">
    <h1 class="mt-4">Sản phẩm trong kho</h1>
    <ol class="breadcrumb mb-4">
      <li class="breadcrumb-item active">Quản lý kho</li>
    </ol>
    <div class="mb-3 d-flex justify-content-start gap-2">
      <button class="btn btn-primary mr-2" (click)="openCreateProductModal()">Tạo sản phẩm</button>
      <button class="btn btn-success mr-2" (click)="openInputModal()">Nhập kho</button>
      <button class="btn btn-warning" (click)="openOutputModal()">Xuất kho</button>
    </div>
    
    <!-- Search Section -->
    <div class="mb-3">
      <div class="row">
        <div class="col-md-6">
          <div class="input-group">
            <input type="text" 
                   class="form-control" 
                   placeholder="Tìm kiếm sản phẩm theo tên hoặc SKU..." 
                   [(ngModel)]="searchTerm" 
                   (input)="onSearchChange()"
                   name="searchTerm">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" 
                      type="button" 
                      (click)="clearSearch()" 
                      [disabled]="!searchTerm">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <span class="text-muted">
              Hiển thị {{filteredProducts.length}} / {{inventoryProducts.length}} sản phẩm
            </span>
          </div>
        </div>
      </div>
    </div>
    
    <div *ngIf="loading" class="alert alert-info">Đang tải dữ liệu...</div>
    <div *ngIf="error" class="alert alert-danger">{{error}}</div>
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th scope="col">Sản phẩm</th>
            <th scope="col">SKU</th>
            <th scope="col">Số lượng còn lại</th>
            <th scope="col">Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredProducts" (click)="openHistoryModal(item)">
            <td><img [src]="item.image" alt="" style="width:40px;height:40px;object-fit:cover;" class="mr-2 product-image" (mouseenter)="showImagePreview($event, item.image)" (mouseleave)="hideImagePreview()" (mousemove)="updateImagePreview($event)"> {{item.name}}</td>
            <td>{{item.sku}}</td>
            <td>{{item.currentNumber}}</td>
            <td>
              <button class="btn btn-sm btn-primary mr-1" (click)="openEditProductModal(item); $event.stopPropagation();">Sửa</button>
              <button class="btn btn-sm btn-danger" (click)="confirmDeleteProduct(item); $event.stopPropagation();">Xóa</button>
            </td>
          </tr>
          <tr *ngIf="filteredProducts.length === 0 && !loading && !error">
            <td colspan="4" class="text-center text-muted">
              <i class="fas fa-search fa-2x mb-2"></i>
              <br>
              Không tìm thấy sản phẩm nào phù hợp với từ khóa "{{searchTerm}}"
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Modals for create, input, output, and history will go here -->
    <ng-template #createProductModal> </ng-template>
    <ng-template #inputModal> </ng-template>
    <ng-template #outputModal> </ng-template>
    <ng-template #historyModal> </ng-template>
    <!-- Create Product Modal -->
    <div class="modal fade" id="createProductModal" tabindex="-1" role="dialog" aria-labelledby="createProductModalLabel" aria-hidden="true" #createProductModalRef>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createProductModalLabel">Tạo sản phẩm mới</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeCreateProductModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form (ngSubmit)="submitCreateProduct()" #createProductForm="ngForm">
            <div class="modal-body">
              <div class="form-group">
                <label>SKU</label>
                <input type="text" class="form-control" [(ngModel)]="newProduct.sku" name="sku" required />
              </div>
              <div class="form-group">
                <label>Tên sản phẩm</label>
                <input type="text" class="form-control" [(ngModel)]="newProduct.name" name="name" required />
              </div>
              <div class="form-group">
                <label>Ảnh sản phẩm</label>
                <input type="file" class="form-control-file" (change)="onImageSelected($event)" accept="image/*" />
                <div *ngIf="imageUpload.loading" class="text-info mt-2">Đang tải ảnh lên...</div>
                <div *ngIf="imageUpload.error" class="text-danger mt-2">{{imageUpload.error}}</div>
                <img *ngIf="newProduct.image" [src]="newProduct.image" alt="Preview" style="max-width: 100px; max-height: 100px; margin-top: 10px;" class="product-image" (mouseenter)="showImagePreview($event, newProduct.image)" (mouseleave)="hideImagePreview()" (mousemove)="updateImagePreview($event)" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeCreateProductModal()">Đóng</button>
              <button type="submit" class="btn btn-primary" [disabled]="createProductForm.invalid || imageUpload.loading">Tạo sản phẩm</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Input Inventory Modal -->
    <div class="modal fade" id="inputModal" tabindex="-1" role="dialog" aria-labelledby="inputModalLabel" aria-hidden="true" #inputModalRef>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="inputModalLabel">Nhập kho</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeInputModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form (ngSubmit)="submitInputModal()" #inputForm="ngForm">
            <div class="modal-body">
              <div class="form-group">
                <label>Sản phẩm</label>
                <ng-select [items]="inventoryProducts"
                           bindLabel="name"
                           bindValue="id"
                           [groupBy]="groupByFirstWord"
                           [(ngModel)]="inputModel.productId"
                           name="productId"
                           [searchable]="true"
                           [clearable]="false"
                           required>
                  <ng-template ng-label-tmp let-item="item">
                    <img *ngIf="item.image" [src]="item.image" width="30" height="30" style="object-fit:cover; margin-right:5px;" class="product-image" (mouseenter)="showImagePreview($event, item.image)" (mouseleave)="hideImagePreview()" (mousemove)="updateImagePreview($event)"> {{item.name}}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <img *ngIf="item.image" [src]="item.image" width="30" height="30" style="object-fit:cover; margin-right:5px;" class="product-image" (mouseenter)="showImagePreview($event, item.image)" (mouseleave)="hideImagePreview()" (mousemove)="updateImagePreview($event)"> {{item.name}}
                  </ng-template>
                </ng-select>
              </div>
              <div class="form-group">
                <label>Số lượng</label>
                <input type="number" class="form-control" [(ngModel)]="inputModel.number" name="number" min="1" required />
              </div>
              <div class="form-group">
                <label>Ghi chú</label>
                <input type="text" class="form-control" [(ngModel)]="inputModel.note" name="note" />
              </div>
              <div *ngIf="inputModalError" class="alert alert-danger">{{inputModalError}}</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeInputModal()">Đóng</button>
              <button type="submit" class="btn btn-success" [disabled]="inputForm.invalid || inputModalLoading">Nhập kho</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Output Inventory Modal -->
    <div class="modal fade" id="outputModal" tabindex="-1" role="dialog" aria-labelledby="outputModalLabel" aria-hidden="true" #outputModalRef>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="outputModalLabel">Xuất kho</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeOutputModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form (ngSubmit)="submitOutputModal()" #outputForm="ngForm">
            <div class="modal-body">
              <div class="form-group">
                <label>Sản phẩm</label>
                <ng-select [items]="inventoryProducts"
                           bindLabel="name"
                           bindValue="id"
                           [groupBy]="groupByFirstWord"
                           [(ngModel)]="outputModel.productId"
                           name="outputProductId"
                           [searchable]="true"
                           [clearable]="false"
                           required>
                    <ng-template ng-label-tmp let-item="item">
                      <img *ngIf="item.image" [src]="item.image" width="30" height="30" style="object-fit:cover; margin-right:5px;" class="product-image" (mouseenter)="showImagePreview($event, item.image)" (mouseleave)="hideImagePreview()" (mousemove)="updateImagePreview($event)"> {{item.name}}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <img *ngIf="item.image" [src]="item.image" width="30" height="30" style="object-fit:cover; margin-right:5px;" class="product-image" (mouseenter)="showImagePreview($event, item.image)" (mouseleave)="hideImagePreview()" (mousemove)="updateImagePreview($event)"> {{item.name}}
                    </ng-template>
                  </ng-select>
</div>
              <div class="form-group">
                <label>Số lượng</label>
                <input type="number" class="form-control" [(ngModel)]="outputModel.number" name="outputNumber" min="1" required />
              </div>
              <div class="form-group">
                <label>Ghi chú</label>
                <input type="text" class="form-control" [(ngModel)]="outputModel.note" name="outputNote" />
              </div>
              <div *ngIf="outputModalError" class="alert alert-danger">{{outputModalError}}</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeOutputModal()">Đóng</button>
              <button type="submit" class="btn btn-warning" [disabled]="outputForm.invalid || outputModalLoading">Xuất kho</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Inventory History Modal -->
    <div class="modal fade" id="historyModal" tabindex="-1" role="dialog" aria-labelledby="historyModalLabel" aria-hidden="true" #historyModalRef>
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="historyModalLabel">Lịch sử nhập/xuất kho: {{historyProduct?.name}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeHistoryModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div *ngIf="historyLoading" class="alert alert-info">Đang tải lịch sử...</div>
            <div *ngIf="historyError" class="alert alert-danger">{{historyError}}</div>
            <div *ngIf="!historyLoading && !historyError">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Người thao tác</th>
                    <th>Thời gian</th>
                    <th>Loại</th>
                    <th>Số lượng</th>
                    <th>Ghi chú</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let record of historyRecords">
                    <td>{{record.createdBy}}</td>
                    <td>{{(record.createdAt | date:'yyyy-MM-ddTHH:mm:ss') | date:'dd/MM/yyyy HH:mm':'GMT+7'}}</td>
                    <td>
                      <span [ngClass]="{'text-success': record.isInput, 'text-danger': !record.isInput}">
                        {{record.isInput ? 'Nhập kho' : 'Xuất kho'}}
                      </span>
                    </td>
                    <td>{{record.number}}</td>
                    <td>{{record.note}}</td>
                  </tr>
                  <tr *ngIf="historyRecords.length === 0">
                    <td colspan="5" class="text-center">Không có lịch sử</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeHistoryModal()">Đóng</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Product Modal -->
    <div class="modal fade" id="editProductModal" tabindex="-1" role="dialog" aria-labelledby="editProductModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editProductModalLabel">Sửa sản phẩm</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeEditProductModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form (ngSubmit)="submitEditProduct()" #editProductForm="ngForm">
            <div class="modal-body">
              <div class="form-group">
                <label>SKU</label>
                <input type="text" class="form-control" [(ngModel)]="editProduct.sku" name="sku" required />
              </div>
              <div class="form-group">
                <label>Tên sản phẩm</label>
                <input type="text" class="form-control" [(ngModel)]="editProduct.name" name="name" required />
              </div>
              <div class="form-group">
                <label>Ảnh sản phẩm</label>
                <input type="text" class="form-control" [(ngModel)]="editProduct.image" name="image" />
                <img *ngIf="editProduct.image" [src]="editProduct.image" alt="Preview" style="max-width: 100px; max-height: 100px; margin-top: 10px;" class="product-image" (mouseenter)="showImagePreview($event, editProduct.image)" (mouseleave)="hideImagePreview()" (mousemove)="updateImagePreview($event)" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeEditProductModal()">Đóng</button>
              <button type="submit" class="btn btn-primary">Lưu</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Delete Product Confirmation Modal -->
    <div class="modal fade" id="deleteProductModal" tabindex="-1" role="dialog" aria-labelledby="deleteProductModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteProductModalLabel">Xóa sản phẩm</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDeleteProductModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Bạn có chắc chắn muốn xóa sản phẩm này không?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeDeleteProductModal()">Hủy</button>
            <button type="button" class="btn btn-danger" (click)="deleteProduct()">Xóa</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Image Preview Tooltip -->
  <div id="imagePreviewTooltip" class="image-preview-tooltip" [style.display]="imagePreviewVisible ? 'block' : 'none'" [style.left.px]="imagePreviewX" [style.top.px]="imagePreviewY">
    <img [src]="imagePreviewSrc" alt="Preview" class="preview-image">
  </div>
</main> 
